(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['xpath'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('xpath'));
    } else {
        // Browser globals (root is window)
        Object.assign(root, factory(root.xpath));
    }
}(typeof self !== 'undefined' ? self : this, function (xpathFallback) {
    

    // need to use same instance of xpath across all code since mixing and matching causes
    // types to not match up in xpath library's use of instanceof

    // Other places where the xpath root object is used:
    // - xpath.function.helpers.js
    // - ruleEditor.js
    // - submitsoapparameters.js

    // When XPathEngine is moved out to a module, we should change all of these files to
    // use xpath from a module instead of the global variable

    // xpathFallback allows us to use xpath functionality in unit tests (non-browser environment)
    var xpath = (typeof window !== 'undefined' && window.xpath) || xpathFallback;

    var XPathParser = xpath.XPathParser;
    var XPathContext = xpath.XPathContext;


    function ContextMenuItem(action, xmlToEdit, caption, showIf) {
        this.action = action;
        this.xmlToEdit = xmlToEdit;
        this.caption = caption;
        this.showIf = showIf;
    }

    var xPathParser = null;
    var evaluateXPath = function (node, path, options) {
        var parser = xPathParser || new XPathParser(),
            parsed = parser.parse(path),
            execContext = new XPathContext(options.variables, options.namespaces, options.functions),
            result;
        xPathParser = parser;

        execContext.expressionContextNode = node;

        result = parsed.evaluate(execContext);

        return result;
    };

    // last non-module file that references XPathEngine is:
    // nodesHelper.js
    function XPathEngine(options) {
        if (options) {
            this.nsr = options.namespaceResolver || null;
            this.baseNode = options.baseNode || null;
            this.functions = options.functions || null;
        }
    }

    XPathEngine.prototype.nsr = null;
    XPathEngine.prototype.baseNode = null;
    XPathEngine.prototype.functions = null;

    XPathEngine.prototype.getContextFromOptions = function (options) {
        return (options && options.context) || this.baseNode;
    };

    // options available are: context - the context node on which to evaluate the expression
    XPathEngine.prototype.evaluateXPath = function (xpathExpression, options) {
        var context = this.getContextFromOptions(options);
        var namespaces = (options && options.namespaces) || this.nsr;

        return evaluateXPath(
            context,
            xpathExpression,
            {
                namespaces: namespaces,
                functions: this.functions,
            }
        );
    };


    // 2020-07-01 - Moved UpgradeEngine to upgradeEngine.js

    return {
        ContextMenuItem: ContextMenuItem,

        XPathEngine: XPathEngine,
    };
}));

